var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"supplier"}},[_c('pre-project')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }